// extracted by mini-css-extract-plugin
export default {"topic":"topic_topic__aGrOg","trending_negative":"topic_trending_negative__YgLns","trending_positive":"topic_trending_positive__eWdFT"};